<template>
  <vs-card class="w-4/12">
    <vs-alert class="mb-10"> No hemos realizado una consulta de buro para esta persona moral.</vs-alert>

    <vs-input class="w-full" label="Folio Otorgante" v-model="issuerKey" />
    <vs-input class="w-full mt-2" label="Razón social" v-model="socialName" />
    <vs-input class="w-full mt-2" label="RFC" v-model="rfc" />
    <vs-input class="w-full mt-2" label="Dirección" v-model="street" />
    <vs-input class="w-full mt-2" label="Código postal" v-model="postalCode" />
    <vs-input class="w-full mt-2" label="Colonia" v-model="neighborhood" />
    <vs-input class="w-full mt-2" label="Municipio" v-model="municipality" />
    <vs-input class="w-full mt-2" label="Ciudad" v-model="city" />
    <vs-input class="w-full mt-2" label="Estado" v-model="state" />
    <vs-input class="w-full mt-2" label="País" v-model="country" />

    <vs-button @click="submit()" class="mt-5 w-full">
      Consultar búro de credito
    </vs-button>
  </vs-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: "BusinessProfileCdcForm",
  components: {VueApexCharts},
  props: {
    issuerKey: {
      type: String,
      required: false,
      default: ''
    },
    socialName: {
      type: String,
      required: true
    },
    rfc: {
      type: String,
      required: true
    },
    street: {
      type: String,
      required: true
    },
    postalCode: {
      type: String,
      required: true
    },
    neighborhood: {
      type: String,
      required: true
    },
    municipality: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    country: {
      type: String,
      required: true
    }
  },
  methods: {
    submit() {
      this.$emit("onSubmit", this.$props)
    }
  }
}
</script>

<style scoped>

</style>
